import { createSelector } from 'reselect'
import { selectMailboxesIncludingInaccessible } from './selectMailboxesIncludingInaccessible'

export const selectDemoMailboxId = createSelector(
  selectMailboxesIncludingInaccessible,
  mailboxes => (mailboxes || []).find(m => m?.state === 'demo')?.id
)
